'use client';

import { PropsWithChildren } from 'react';

import { MainPanel } from '@strategyProfile/components/StrategyPageMain/Panels/MainPanel';
import { StrategyPageMainPanelTab } from '@strategyProfile/components/StrategyPageMain/Panels/MainPanel/strategyPageMainPanelTab';
import { ProfitDistributionPanel } from '@strategyProfile/components/StrategyPageMain/Panels/ProfitDistributionPanel';

import { PublicStrategy } from '@/api/copy-trading/types';
import { Container } from '@/blocks/components/Container';

import { PerformancePanel } from './Panels/PerformancePanel';
import styles from './styles.module.scss';

function Layout({ children }: PropsWithChildren<{}>) {
  return <div className={styles.layout}>{children}</div>;
}

Layout.Sidebar = function LayoutSidebar({ children }: PropsWithChildren<{}>) {
  return <div className={styles.layoutSidebar}>{children}</div>;
};

type StrategyPageMainSectionProps = {
  mainPanelTabs: { [key in StrategyPageMainPanelTab]?: React.ReactNode };
  strategy: PublicStrategy;
};

export function StrategyPageMain({ strategy, mainPanelTabs }: StrategyPageMainSectionProps) {
  return (
    <Container>
      <Layout>
        <Layout.Sidebar>
          <PerformancePanel strategy={strategy} />
          <ProfitDistributionPanel strategy={strategy} />
        </Layout.Sidebar>
        <MainPanel strategy={strategy} mainPanelTabs={mainPanelTabs} />
      </Layout>
    </Container>
  );
}
